import React from "react";
import Payments from "./Payments";
import Costs from "./Costs";
import Lang from "../../../components/Lang";
import CashWithdrawals from "./CashWithdrawals";

/**
 * PaymentsAndCosts wrapper component.
 * Renders a card container with payment type label, payments, costs, and optional cash withdrawals.
 * Uses flat premium design language with Tailwind utilities.
 *
 * @param {Object} props - Component props
 * @param {Array} props.payments - Array of payment records
 * @param {number} props.paymentType - Payment type (0 = cash, 1 = internet)
 * @param {string} props.label - Label key for translation
 * @param {Object} props.date - Current date filter
 * @param {Object} props.costs - Costs data object
 * @returns {JSX.Element} Card with payments and costs sections
 * @author Forge
 * @date 2026-04-08
 * @version 2.0
 */
export default function PaymentsAndCosts({payments, paymentType, label, date, costs}) {

    return (
      <div className="bg-white border border-slate-200 rounded-[12px] shadow-[0_8px_30px_rgba(0,0,0,0.06)] overflow-hidden">
        <div className="px-4 py-3 bg-slate-50 border-b border-slate-100">
          <div className="money-label" style={{ marginBottom: 0 }}>
            <Lang w={label} />
          </div>
        </div>
        <div className="p-4">
          <Payments
            payments={payments}
          />
          <div className="mt-4">
            <Costs
              costType={paymentType}
              date={date}
              costs={costs}
            />
          </div>
          {paymentType && paymentType === 0 && (
            <div className="mt-4">
              <CashWithdrawals date={date} />
            </div>
          )}
        </div>
      </div>
    );
}